import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

import { DEFAULT_SORT, DEFAULT_VIEW, ViewMode } from '../constants';
import { SortOption } from '../types';

export class ProjectPreferencesUtils {
    static getSortPreference(): SortOption | '' {
        const saved = localStorageUtil.get<SortOption | ''>(ELocalStorageKeys.PROJECTS_SORT_PREFERENCE);
        return saved || DEFAULT_SORT;
    }

    static setSortPreference(sortBy: SortOption | ''): void {
        localStorageUtil.set(ELocalStorageKeys.PROJECTS_SORT_PREFERENCE, sortBy);
    }

    static getViewPreference(): ViewMode {
        const saved = localStorageUtil.get<ViewMode>(ELocalStorageKeys.PROJECTS_VIEW_PREFERENCE);
        return saved || DEFAULT_VIEW;
    }

    static setViewPreference(viewMode: ViewMode): void {
        localStorageUtil.set(ELocalStorageKeys.PROJECTS_VIEW_PREFERENCE, viewMode);
    }

    static clearPreferences(): void {
        localStorageUtil.remove(ELocalStorageKeys.PROJECTS_SORT_PREFERENCE);
        localStorageUtil.remove(ELocalStorageKeys.PROJECTS_VIEW_PREFERENCE);
    }
}

